import gql from 'graphql-tag';

export const GET_USERS = gql`
  query GetUsers {
    getUsers {
      id
      email
      full_name
      phone
      is_activate
      platform
      created_at
      updated_at
      role {
        id
      }
      addresses {
        id
        address
        is_default
        municipality_id
        coordinate {
          type
          coordinates
        }
        municipality {
          id
          name
        }
      }
    }
  }
`;

export const SEARCH_USERS_BY_MUNICIPALITY = gql`
  query SearchUsersByMunicipality($municipality_id: Int!, $search: String, $limit: Int) {
    searchUsersByMunicipality(municipality_id: $municipality_id, search: $search, limit: $limit) {
      id
      email
      full_name
      phone
      is_activate
      addresses {
        id
        address
        is_default
        municipality_id
      }
    }
  }
`;

// Query to get admin users for supervisor assignment
export const GET_ADMIN_USERS = gql`
  query GetAdminUsers {
    getAdminUsers {
      id
      email
      full_name
      is_activate
      platform
    }
  }
`;

export const GET_USER = gql`
  query GetUser($id: Int!) {
    getUser(user_id: $id) {
      id
      email
      full_name
      phone
      is_activate
      platform
      created_at
      updated_at
      role {
        id
        role_name
      }
      addresses {
        id
        address
        is_default
        municipality_id
        coordinate {
          type
          coordinates
        }
        municipality {
          id
          name
        }
      }
    }
  }
`;

// Mutaciones (Mutations)
export const CREATE_USER = gql`
  mutation CreateUser(
    $email: String!,
    $password_hash: String!,
    $full_name: String!,
    $phone: String!,
    $addresses: [AddressInput!]!,
    $source: String,
    $role_id: Int
  ) {
    createUser(
      email: $email,
      password_hash: $password_hash,
      full_name: $full_name,
      phone: $phone,
      addresses: $addresses,
      source: $source,
      role_id: $role_id
    ) {
      id
      email
      full_name
      phone
      is_activate
      platform
      created_at
      updated_at
      role {
        id
        role_name
      }
      addresses {
        id
        address
        is_default
        municipality {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $user_id: Int!,
    $email: String,
    $password_hash: String,
    $full_name: String,
    $phone: String,
    $is_activate: Boolean,
    $addresses: [AddressInput!]
  ) {
    updateUser(
      user_id: $user_id,
      email: $email,
      password_hash: $password_hash,
      full_name: $full_name,
      phone: $phone,
      is_activate: $is_activate,
      addresses: $addresses
    ) {
      id
      email
      full_name
      phone
      is_activate
      platform
      created_at
      updated_at
      addresses {
        id
        address
        is_default
        municipality {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($user_id: Int!) {
    deleteUser(user_id: $user_id)
  }
`;
